import { AssetTagList } from './AssetTagList';
import { deviceTypeToDisplayedString } from './TelematicsName';
import type { AssetDevicesProps } from './types';

export const AssetDevices = (props: AssetDevicesProps) => {
    return (
        <AssetTagList
            items={props.assetDevices.map(associatedDevice => ({
                id: associatedDevice.device.id,
                label: deviceTypeToDisplayedString(associatedDevice.device.type),
            }))}
            icon={props.icon ?? 'device'}
        />
    );
};
